import type { ReactNode } from 'react'
import { cn } from '@/utils'

type TrayResultsToolbarProps = {
  count: number
  /** False while loading / errored / nothing to show — the row keeps its height either way. */
  showCount: boolean
  /** Right-aligned controls, typically a `TraySortButton`. */
  children?: ReactNode
}

/** "N results" (announced politely) on the left, sort control on the right. */
export function TrayResultsToolbar({ count, showCount, children }: TrayResultsToolbarProps) {
  return (
    <div className="flex w-full min-w-0 items-center justify-between gap-2">
      {showCount ? (
        <span
          className={cn(
            'text-sm font-normal leading-5',
            count === 0 ? 'text-muted-foreground' : 'text-primary'
          )}
          aria-live="polite"
          aria-atomic="true"
        >
          {count} results
        </span>
      ) : (
        <span className="text-sm leading-5 text-transparent" aria-hidden="true">
          0 results
        </span>
      )}
      {children}
    </div>
  )
}
